<template>
	<div class="container">
    <div class="plat-name">临安区海内外高层次人才创新创业项目管理系统</div>
    <div class="login">
      <div class="form">
        <div class="title">用户登录</div>
        <div class="form-item">
          <div class="label">手机号</div>
          <van-field v-model="phone" placeholder="请输入手机号" maxlength="11"/>
        </div>
        <div class="form-item">
          <div class="label">验证码</div>
          <van-field  v-model="smsCode" placeholder="请输入验证码" maxlength="6">
            <template #button>
              <div class="sms-btn" @click="sendSmsCode" :style="!isTimeOver && { color: '#ccc' }">{{timeOut}}</div>
            </template>
          </van-field>
        </div>
        <van-button
          type="primary"
          :loading="loading"
          loading-text="登录中..."
          block
          @click="handleLogin"
        >登 录</van-button
        >
      </div>
    </div>


	</div>
</template>

<script>
	import { getSmsCode, login } from '@/api/HttpRequestAPI';
  import {toast} from '@/utils'
  import {setLoginToken} from '@/cache/Cache'
	export default {
		name: 'login',
    components:{
    },
		data() {
			return {
				loading: false,
				agreementFlag: true,
        phone:'',
        smsCode:'',
				formData: {
					username: '',
					password: '',
					rememberMe: false,
				},

        //验证码倒计时
        timeOut: "",
        isTimeOver: false,
			};
		},
    mounted() {
      this.getTime(0)
    },

    methods: {
      getTime(wait) {
        let _wait = wait;
        if (wait === 0) {
          this.timeOut = "获取验证码";
          this.isTimeOver = true;
          wait = _wait;
        } else {
          this.timeOut = "稍后重试(" + wait + "s)";
          this.isTimeOver = false;
          wait--;
          setTimeout(() => {
            this.getTime(wait);
          }, 1000);
        }
      },
      sendSmsCode(){
        if (!this.isTimeOver) {
          return;
        }
        if (!this.phone) {
          toast('请输入手机号')
          return;
        }
        if (this.phone.length != 11) {
          toast('手机号格式不正确')
          return;
        }

        let params = {
          phone:this.phone
        }
        getSmsCode(params, (resp)=>{
          this.getTime(60);
          toast('短信验证码发送成功')
        })
      },
			handleLogin() {
				if (!this.phone) {
          toast('请输入手机号')
					return;
				}
				if (!this.smsCode) {
          toast('请输入验证码')
					return;
				}
        try {
          this.loading = true;
          let params = {
            phone:this.phone,
            smsCode:this.smsCode,
          }
          login(params, (resp)=>{
            this.loading = false;
            toast('登录成功')
            let token = resp.data.token
            let isApplyRecord = resp.data.applyRecord
            setLoginToken(token)
            if(isApplyRecord) {
              this.$router.push('/apply-list');
            } else {
              this.$router.push('/apply');
            }

          }, (failResp)=>{
            this.loading = false;
          })

        } catch (error) {
          console.log(error);
        }
			},


		},
	};
</script>

<style lang="less" scoped>
	@import url(./index.less);
</style>
